import { useCallback, useEffect, useState } from "react";
import { Button, Label } from "reactstrap";
import { EventsService } from "../../../globals/services/events.service";
import { SessionsService } from "../../../globals/services/sessions.service";
import styles from "../Settings.module.scss";

interface Session {
    _id: string;
    sessionId: string;
    sessionTitle: string;
    startDate: string;
    startTime: string;
    endTime: string;
    sessionType?: string;
    sessionPrivacy?: string;
}

interface Event {
    _id: string;
    eventTitle: string;
    eventName: string;
    dtStartDate: string;
    dtEndDate: string;
    language: string;
    sessions: Session[];
    seminarTasks?: any[];
}

interface EventResponse {
    _id: string;
    event: Event;
}

interface DuplicateSessionsProps {
    setIsLoading: (isLoading: boolean) => void;
}

const DuplicateSessions = ({ setIsLoading }: DuplicateSessionsProps) => {
    console.log('Initializing DuplicateSessions component');
    
    const [message, setMessage] = useState('');
    const [events, setEvents] = useState<Event[]>([]);
    const [selectedEventId, setSelectedEventId] = useState<string>('');

    useEffect(() => {
        fetchEvents();
    }, []);

    const fetchEvents = async () => {
        console.log('Fetching events...');
        try {
            const response = await EventsService().getEventItems();
            const filteredResponse = response.map((eventResponse: EventResponse) => eventResponse.event);
            console.log('Events fetched successfully:', filteredResponse.length, 'events found');
            setEvents(filteredResponse);
        } catch (error) {
            console.error('Error fetching events:', error);
        }
    };

    const handleEventChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedEventId = e.target.value;
        console.log('Event selected:', selectedEventId);
        
        const selectedEvent = events.find((event) => event._id === selectedEventId);
        console.log('Selected event details:', selectedEvent?.eventTitle);
        
        setSelectedEventId(selectedEventId);
        setMessage('');
    };

    const removeDuplicateSession = async (eventId: string) => {
        console.log('Attempting to remove duplicate sessions for event:', eventId);
        try {
            setIsLoading(true);
            await SessionsService().deleteSessionFromEvent(eventId);
            console.log('Session deleted successfully');
            
            // Refresh events after deletion
            await fetchEvents();
            console.log('Events refreshed after session deletion');
            
        } catch (error) {
            console.error('Error removing duplicate session:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="mb-2 mt-5">
            <h3>Manage Duplicate Sessions</h3>
            <div className="justify-content-around mb-2">
                <h5 className="mt-4">
                    <Label htmlFor="eventSelect">Select Event to check for duplicates</Label>
                </h5>
                <select 
                    className="selectInput mr-3" 
                    id="eventSelect" 
                    value={selectedEventId} 
                    onChange={handleEventChange}
                    style={{ height: '35px', lineHeight: '35px', marginRight: '20px' }}
                >
                    <option value="">Select an event...</option>
                    {events?.length > 0 ? 
                        events.map(({ _id, eventTitle }) => (
                            <option key={_id} value={_id}>{eventTitle}</option>
                        )) : (
                            <option value="" disabled>Loading...</option>
                        )
                    }
                </select>
                <Button
                    onClick={() => removeDuplicateSession(selectedEventId)}
                    className={styles.syncButton}
                    disabled={!selectedEventId}
                >
                    Remove Duplicate Sessions
                </Button>
            </div>

            {message && <div className="mt-2">{message}</div>}
        </div>
    );
};

export default DuplicateSessions; 